import { SimpleDialog } from "@powerdiary/components-library/lib";
import { useResetPasswordContext } from "../../../../context";
import ResetPasswordDialogForm from "./ResetPasswordDialogForm";
import { useMediaQuery, useTheme } from "@mui/material";

export default function ResetPasswordDialog() {
    const { setShowResetPasswordDialog } = useResetPasswordContext();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <SimpleDialog
            open
            onClose={(_, reason) => {
                if (reason === "escapeKeyDown") {
                    setShowResetPasswordDialog(false);
                }
            }}
            dataTestIdSuffix="reset_password"
            dialogTitleText="Reset password"
            handleClose={() => setShowResetPasswordDialog(false)}
            renderContent={() => <ResetPasswordDialogForm />}
            paperProps={{
                sx: {
                    minWidth: isMobile ? "calc(100% - 4px)" : "500px",
                    maxWidth: "500px",
                },
            }}
        />
    );
}
